import { Helmet } from "react-helmet-async";

const SITE_NAME = "The Push Center";
const SITE_URL = "https://blessed-parish-1.preview.emergentagent.com";
const DEFAULT_DESCRIPTION =
  "The Push Center is a church in Portsmouth, VA pastored by Demetrial Donshae Hill. Out of Complacency Into Your Destiny. Sundays 9 AM.";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  path = "",
  type = "website",
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — Out of Complacency Into Your Destiny`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data — Church */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Church",
        "name": "The Push Center",
        "description": DEFAULT_DESCRIPTION,
        "url": SITE_URL,
        "logo": DEFAULT_IMAGE,
        "image": DEFAULT_IMAGE,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "6217 Portsmouth Blvd",
          "addressLocality": "Portsmouth",
          "addressRegion": "VA",
          "postalCode": "23701",
          "addressCountry": "US"
        },
        "sameAs": [
          "https://www.facebook.com/share/1By8zRYFPB/?mibextid=wwXIfr",
          "https://www.instagram.com/pushcenterva"
        ]
      })}</script>
    </Helmet>
  );
}
